import SignInDefault from '../components/public/SignInDefault.vue'
import SignInHrOffice from '../components/public/SignInHrOffice.vue'
import SignUpDefault from '../components/public/SignUpDefault.vue'

const variants = {
    srv1: {
        signIn: SignInDefault,
        signUp: SignUpDefault,
        showAppBar: true,
    },
    srv2: {
        signIn: SignInHrOffice,
        signUp: SignUpDefault,
        showAppBar: false,
    },
}

export const variant = process.env.VUE_APP_VARIANT || 'srv1'
export const publicPages = variants[variant]
